import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/qris-configs'

class QrisConfigsService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** GET /vendors/qris-configs */
  async getData () {
    const result = await this._apiConsume.getData(BASE_URL)
    return result?.data
  }

  /** GET /vendors/qris-configs/:id: used by the Edit flow (viewQrisConfig in the ejs). */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /** POST /vendors/qris-configs */
  async create (payload) {
    const result = await this._apiConsume.postData(payload, BASE_URL)
    return result?.data
  }

  /** PUT /vendors/qris-configs/:id */
  async update (id, payload) {
    const result = await this._apiConsume.putData(payload, `${BASE_URL}/${id}`)
    return result?.data
  }

  /** DELETE /vendors/qris-configs/:id */
  async deleteById (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /**
   * GET /vendors/payment-vendors: replaces the ejs's controller-injected
   * `paymentVendors` local used to populate the Vendor Gateway dropdown.
   */
  async getPaymentVendors () {
    const result = await this._apiConsume.getData('/api/dashboard/payment-vendors')
    return result?.data
  }
}

export default QrisConfigsService
